import pubsub from 'sweet-pubsub';
import * as Sentry from "@sentry/svelte";
import amplitude from 'amplitude-js';
import client, { PUBLIC_CLIENT } from './client';
import Tracker from '@openreplay/tracker';
import "../types/user";
import 'libphonenumber-js';
import toast from './toast';
const AMPLITUDE_API_KEY = "d07c19eb097dad4b443472760ae7b59a";
export const EVENTS = {
    LOGIN: "login",
    INIT_CALL: "initiate_call",
    NUMBER_SELECTED: "number_selected",
    RINGING: "ringing",
    CALL_STARTED: "call_started",
    CALL_ENDED: "call_ended",
    CALL_FAILED: "call_failed",
    CALL_MUTED: "call_muted",
    CALL_UNMUTED: "call_unmuted",
    CALL_HOLD: "call_hold",
    CALL_UNHOLD: "call_unhold",
    CALL_TRANSFERED: "call_transfered",
    CALL_TRANSFER_FAILED: "call_transfer_failed",
    LOGOUT: "logout",
    ERROR_LOG: "error_log",
    SYNC_CONTACT: "sync_contact",
    USER_REGISTRATION: "user_registration_attempt",
    USER_REGISTRATION_FAILURE: "user_registration_attempt_failure",
    NOTE_SAVED: "note_saved",
    RECORDINGS_COPIED: "recordings_copied",
    RECORDINGS_PLAYED: "recordings_played",
    OPEN_CALL_RECORD: "open_call_record",
    CONTACT_SAVED: "contact_saved",
    SURVEY_SAVED: "survey_saved"
};
export const formatDuration = (duration) => {
    let hours = Math.floor(duration / 3600);
    let minutes = Math.floor((duration - hours * 3600) / 60);
    let seconds = Math.floor(duration - hours * 3600 - minutes * 60);
    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;
    return hours + ':' + minutes + ':' + seconds;
};
export const initSentry = (user) => {
    const { id, personal_email: email } = user || {};
    try {
        Sentry.init({
            dsn: "https://ca72041db3ce5d351a0cc9170fecd7b8@o1125524.ingest.us.sentry.io/4507073326088192",
            integrations: [
                Sentry.browserTracingIntegration(),
                // Sentry.replayIntegration(),
                Sentry.dedupeIntegration()
            ],
            // Performance Monitoring
            tracesSampleRate: 1.0,
            // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
            tracePropagationTargets: ["localhost", /^https:\/\/pressone*\.netlify\/app/, "https://pressone-live-call.netlify.app"],
            // // Session Replay
            // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
            // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
            // debug: false,
            initialScope: {
                user: { id, email },
            },
            ignoreErrors: [
                "Non-Error exception captured",
                "Non-Error promise rejection captured",
                "Object captured as promise rejection with keys"
            ]
        });
    }
    catch (e) {
        console.dir(e);
    }
    pubsub.on("user_store_updated", ({ id, personal_email: email }) => {
        Sentry.setUser({ id, email });
    });
};
export const parseMobile = (mobile, prefix = '+234') => {
    if (mobile.startsWith('0')) {
        mobile = mobile.replace('0', prefix);
    }
    else if (mobile.startsWith(prefix.substring(1))) { // e.g starts with 234
        mobile = mobile.replace(prefix.substring(1), prefix);
    }
    else if (!mobile.startsWith('+')) {
        mobile = prefix + mobile;
    }
    return mobile;
};
export const formatter = new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
});
export const formatNumber = (number) => {
    // if it starts with +234, remove the +234 and replace with 0
    // if it starts with 234, remove the 234 and replace with 0
    // if it starts with 0, leave it as it is
    // if it doesn't start with 0, add 0 to the beginning
    if (number.startsWith('+234')) {
        return number.replace('+234', '0');
    }
    else if (number.startsWith('234')) {
        return number.replace('234', '0');
        //   } else if (!number.startsWith('0')) {
        //       return `0${number}`;
    }
    else {
        return number;
    }
};
export const CALL_STATE_CONSTANTS = {
    IDLE: 'idle',
    INCALL: 'inCall',
    RINGING: 'ringing',
    OUTGOING: 'outgoing',
    OUTCALL: 'outCall', // outgoing call answered
};
export const isValidPhone = (phone) => {
    const phoneRegex = new RegExp(/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/, "gm");
    return phoneRegex.test(phone);
};
export const pickOutInitials = (name) => {
    return name.split(' ', 3).map((n) => (n.length >= 1 ? n[0].toUpperCase() : '?')).join('');
};
const openreplay_keys = {
    'hubspot': '6PpRzG4eIUVx65A4V76i',
    'freshworks': 'RLe8RHe68rYIIkJBNMAz',
    'pipedrive': 'xcSCjVWdoiCj7VcujgcT',
    'zendesk': 'lxmPbWXLCHpcGpthUNwT',
    'zoho': 'YxLclbcf6I8FBEa4ay66',
};
const openReplay = new Tracker({
    projectKey: openreplay_keys[process.env.APP_PROJECT_TYPE] || 'pQG2nEEnCYw4fCvVa5Oe',
    ingestPoint: 'https://openreplay.pressone.co/ingest',
    network: {
        capturePayload: true // Capture HTTP payload
    },
    __DISABLE_SECURE_MODE: false
});
export const initOpenReplay = (user) => {
    if (user) {
        openReplay.setUserID(user.personal_email);
    }
    openReplay.start();
};
export class AmplitudeLogger {
    constructor(identifier = null) {
        if (!AmplitudeLogger.logger) {
            amplitude.getInstance(process.env.APP_PROJECT_TYPE).init(AMPLITUDE_API_KEY, identifier);
            AmplitudeLogger.logger = amplitude.getInstance(process.env.APP_PROJECT_TYPE);
        }
        return AmplitudeLogger.logger;
    }
    static getLogger(identifier = null) {
        if (!AmplitudeLogger.logger) {
            return new AmplitudeLogger(identifier);
        }
        return AmplitudeLogger.logger;
    }
    static log(event, details = {}) {
        try {
            return AmplitudeLogger.getLogger().logEvent(`${event} [${process.env.APP_PROJECT_TYPE}]`, details);
        }
        catch (err) {
            console.error(`Amplitude Log failed ${err.toString()}`);
        }
    }
    config() {
        return {};
    }
}
AmplitudeLogger.logger = null;
export class OpenObserveLogger {
    constructor() {
        if (!OpenObserveLogger.logger) {
            OpenObserveLogger.logger = this;
        }
        return OpenObserveLogger.logger;
    }
    static getLogger() {
        if (!OpenObserveLogger.logger) {
            return new OpenObserveLogger();
        }
        return OpenObserveLogger.logger;
    }
    async makeRequest(event, options = {}) {
        const { auth, domain, hostname, url } = this.config();
        const { extension } = options;
        const user_extention = extension;
        if (extension) {
            delete options.extension;
        }
        const payload = [Object.assign({ "__name__": "web_dialer_event", "__type__": "gauge", "organization": "default", "stream_type": "logs", "stream": "default", "domain": domain, "hostname": hostname, "event": event, "extension": user_extention, "_timestamp": (new Date()).getTime(), "value": 1 }, options)];
        return await client.post({
            url,
            level: PUBLIC_CLIENT,
            payload,
            headers: {
                Authorization: `Basic ${auth}`
            },
        });
    }
    config() {
        return {
            url: 'https://openobserve.pressone.co/api/default/ingest/metrics/_json',
            auth: "ZW5naW5lZXJpbmdAcHJlc3NvbmUuY286UU43Y1E2eW9zZm1lMHBLZA==",
            domain: "pressone-full-widget.netlify.app/",
            hostname: "pressone-full-widget"
        };
    }
    /**
     *
     * @param {"user_registration_attempt_failure | user_registration_attempt"} event
     * @param { Object } details
     * @returns Promise
     */
    static log(event, details = {}) {
        return new Promise((resolve, reject) => {
            OpenObserveLogger.getLogger().makeRequest(event, details).then(res => {
                console.log(res);
                resolve(res);
            }).catch(err => {
                console.log(err);
                reject(err);
            });
        });
    }
}
OpenObserveLogger.logger = null;
export const configureCss = (config) => {
    const { primary_bg_color, primary_text_color, secondary_bg_color, secondary_text_color } = config;
    if (secondary_bg_color)
        document.body.style.setProperty('--secondary-bg-color', secondary_bg_color);
    if (primary_bg_color)
        document.body.style.setProperty('--primary-bg-color', primary_bg_color);
    if (primary_text_color)
        document.body.style.setProperty('--primary-text-color', primary_text_color);
    if (secondary_text_color)
        document.body.style.setProperty('--secondary-text-color', secondary_text_color);
};
export const ICONS = {
    // for intercom
    logo: "https://cdn.glitch.global/b92f6d20-2ecc-44e1-bba4-b73e14ed8304/logo-64x64.png?v=1725435550338",
    ng: "https://cdn.glitch.global/b92f6d20-2ecc-44e1-bba4-b73e14ed8304/ng-logo.png?v=1725435683918",
    us: "https://cdn.glitch.global/b92f6d20-2ecc-44e1-bba4-b73e14ed8304/us-logo.png?v=1725435709924",
    uk: "https://cdn.glitch.global/b92f6d20-2ecc-44e1-bba4-b73e14ed8304/uk-logo.png?v=1725435699121",
    ca: "https://cdn.glitch.global/b92f6d20-2ecc-44e1-bba4-b73e14ed8304/ca-logo.png?v=1725435623727",
    ky: "https://cdn.glitch.global/b92f6d20-2ecc-44e1-bba4-b73e14ed8304/ky-logo.png?v=1725435662246",
    avatar: "https://cdn.glitch.global/b92f6d20-2ecc-44e1-bba4-b73e14ed8304/_avatar.png?v=1725435401347"
    // others
    // logo: "./favicon.png",
    // ng: "./images/icons/ng-logo.png",
    // us: "./images/icons/us-logo.png",
    // uk: "./images/icons/uk-logo.png",
    // ca: "./images/icons/ca-logo.png",
    // ky: "./images/icons/ky-logo.png",
    // avatar: "./images/_avatar.png"
};
export const defaultCountry = {
    code: 'NG',
    tel: '+234',
    name: 'Nigeria'
};
export const countries = [
    { code: 'NG', tel: '+234', name: 'Nigeria' },
    { code: 'US', tel: '+1', name: 'United States' },
    { code: 'UK', tel: '+44', name: 'United Kingdom' },
    { code: 'CA', tel: '+1', name: 'Canada' },
    { code: 'KY', tel: '+254', name: 'Kenya' }
];
export const copyText = (text) => {
    navigator.clipboard.writeText(text).then(() => {
        toast.success('Successfully copied to clipboard');
    }).catch((error) => {
        console.error('Could not copy text:', error);
        toast.error({ message: 'An error occured while copying content' });
    });
};
